// Mở popup dùng thử/nâng cấp PRO TẠI CHỖ từ bất kỳ đâu (kể cả code không phải React).
// GlobalProTrialModal (mount 1 lần trong App) lắng nghe sự kiện này để hiện popup.
export type ProSite = 'ebook' | 'eng'

export function openProTrial(site: ProSite = 'ebook') {
  try {
    window.dispatchEvent(new CustomEvent('vatli365:open-pro-trial', { detail: { site } }))
  } catch {
    /* SSR/no-window: bỏ qua */
  }
}

// Nhận biết lỗi thiếu quyền PRO từ backend (403 + detail có 'PRO'/'require_pro').
export function isProError(err: unknown): boolean {
  const msg = String((err as Error)?.message || err || '')
  return /\b403\b/.test(msg) && /(pro|PRO|require_pro|nâng cấp|dùng thử)/i.test(msg)
}
